import api from '../utils/api';
import DispatchConstants from '../constants/DispatchConstants';
import LeadsDetails from '../model/LeadsDetails';

const LeadActions = {
  getLead(params = {}) {
    return (dispatch) =>
      dispatch(api.users.leads.lead(params))
        .then((result) => {
          if (result.success) {
            const leadsDetailsModel = LeadsDetails(result.response);

            return dispatch({
              type: DispatchConstants.LEAD_SUCCESS,
              payload: leadsDetailsModel,
            });
          }

          throw new Error({
            message: 'message',
          });
        })
        .catch((err) => {
          dispatch({
            type: DispatchConstants.LEAD_FAIL,
            payload: err,
          });
          return Promise.reject(err);
        });
  },
  updateLeadStatus(params = {}) {
    return (dispatch) =>
      dispatch(api.users.leads.updateLeadStatus(params))
        .then((result) => {
          if (result.success) {
            return result.response;
          }
          return Promise.reject(result.error);
        })
        .catch((err) => new Error(err));
  },
  addMessage(params = {}) {
    return (dispatch) =>
      dispatch(api.users.leads.addMessage(params))
        .then((result) => {
          if (result.success) {
            return result.response;
          }
          return Promise.reject(result.error);
        })
        .catch((err) => new Error(err));
  },
};

export default LeadActions;
